export const environment = {
  production: false,
  apiUrl: 'https://epermits-dev.fs2c.usda.gov:8080/',
  buildDate: 'Tue Jan 16 2018 17:06:56 GMT-0500 (EST)',
  version: '1.1.0',
  envName: 'development',
  changeRequestForm: 'https://docs.google.com/forms/d/e/1FAIpQLSca7taTXY7xUTDvcnyR7rf7jkfvinBPtGqbNWgLBd3Dy6kH4Q/viewform',
  dataDog: {
    applicationId: 'ed227554-7eb7-486f-9b1f-5d539cb010f7',
    clientToken: 'pub49cd8a72c1a5a9eace92acfa06602f43'
  }
};
